import { render, staticRenderFns } from "./model-setting.vue?vue&type=template&id=257c9108"
import script from "./model-setting.vue?vue&type=script&lang=js"
export * from "./model-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports